import axios from '../../utils/axiosConfig';
//ss
// Action types
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAIL = 'LOGIN_FAIL';
const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGOUT = 'LOGOUT';
const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
const RESEND_CONFIRMATION_SUCCESS = 'RESEND_CONFIRMATION_SUCCESS';
const RESEND_CONFIRMATION_FAIL = 'RESEND_CONFIRMATION_FAIL';

// NEW: keep Redux in sync when Axios interceptor refreshes tokens
const AUTH_REFRESHED = 'AUTH_REFRESHED';
export const authRefreshed = (payload) => ({ type: AUTH_REFRESHED, payload });

export const login = (email, password) => async (dispatch) => {
  try {
    const res = await axios.post(
      '/auth/login',
      { email, password },
      { headers: { 'Content-Type': 'application/json' } }
    );

    localStorage.removeItem('explicit_logout');

    // Persist + set header for subsequent requests
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));

    dispatch({ type: LOGIN_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    const errorMessage = err?.response?.data?.message || 'Login failed';
    const canResend = err?.response?.data?.canResend || false;

    dispatch({ type: LOGIN_FAIL, payload: errorMessage });
    const error = new Error(errorMessage);
    error.canResend = canResend;
    throw error;
  }
};

export const register = (role, formData) => async (dispatch) => {
  try {
    const res = await axios.post(`/${role}/register`, formData);
    dispatch({ type: REGISTER_SUCCESS, payload: res.data });
    return res.data;
  } catch (err) {
    const message = err?.response?.data?.message || 'Registration failed';
    dispatch({ type: AUTH_ERROR, payload: message });
    throw err;
  }
};

export const checkAuth = () => async (dispatch) => {
  try {
    const token = localStorage.getItem('token');

    // If no token, user is simply logged out. Don't call /auth/check.
    if (!token) return null;

    const res = await axios.get('/auth/check');

    if (res?.data?.user) {
      localStorage.setItem('user', JSON.stringify(res.data.user));
    }

    dispatch({
      type: LOGIN_SUCCESS,
      payload: { token, user: res.data.user },
    });

    return res.data;
  } catch (err) {
    const status = err?.response?.status;

    if (status === 401) {
      // stale token -> clear quietly
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // IMPORTANT: don't set "Session expired" as a global error
      dispatch({ type: LOGOUT, payload: null });
      return null;
    }

    dispatch({ type: AUTH_ERROR, payload: 'Auth check failed' });
    return null;
  }
};

export const logout = () => async (dispatch) => {
  // ✅ 1) mark explicit logout first
  localStorage.setItem('explicit_logout', '1');

  try {
    // Clear refresh cookie on the server
    await axios.post('/auth/logout'); // your axios instance already has withCredentials: true
  } catch (_) {
    // ignore
  }

  // Client cleanup
  localStorage.removeItem('token');
  localStorage.removeItem('user');

  dispatch({ type: LOGOUT });
};

export const forgotPassword = (email) => async (dispatch) => {
  dispatch({ type: FORGOT_PASSWORD_REQUEST });
  try {
    const res = await axios.post(
      '/auth/forgot-password',
      { email },
      { headers: { 'Content-Type': 'application/json' } }
    );
    dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: res.data.message });
    return res.data.message;
  } catch (err) {
    const msg = err?.response?.data?.message || 'Request failed';
    dispatch({ type: FORGOT_PASSWORD_FAIL, payload: msg });
    throw new Error(msg);
  }
};

export const resendConfirmation = (email) => async (dispatch) => {
  try {
    const res = await axios.post(
      '/auth/resend-confirmation',
      { email },
      { headers: { 'Content-Type': 'application/json' } }
    );
    dispatch({ type: RESEND_CONFIRMATION_SUCCESS, payload: res.data.message });
    return res.data.message;
  } catch (err) {
    const msg =
      err?.response?.data?.message || 'Failed to resend confirmation email';
    dispatch({ type: RESEND_CONFIRMATION_FAIL, payload: msg });
    throw new Error(msg);
  }
};

export const bootstrapAuth = () => async (dispatch) => {
  dispatch({ type: 'AUTH_BOOTSTRAP_START' });

  try {
    // IMPORTANT: backend refresh is GET
    const res = await axios.get('/auth/refresh');

    dispatch({
      type: 'AUTH_REFRESHED',
      payload: { token: res.data.token, user: res.data.user },
    });
  } catch (err) {
    // no refresh cookie / expired refresh → ensure clean state
    dispatch({ type: 'LOGOUT', payload: null });
  } finally {
    dispatch({ type: 'AUTH_BOOTSTRAP_DONE' });
  }
};
